import React, { useContext } from 'react';
import { Viewport } from '../utils';
import { EditorContext } from './EditorContext';
import NotSmall from './NotSmall';
import Small from './Small';
import SubjectPicker from './SubjectPicker';

const Editor: React.FC = () => {
  const { state } = useContext(EditorContext);

  return (
    <div className="fixed absolute--fill flex flex-column">
      {state.showSubjectPicker && <SubjectPicker />}
      {!state.showSubjectPicker && <Viewport small={<Small />} large={<NotSmall />} />}
    </div>
  );
};

export default Editor;
